import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=66d7ef9d"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports